import React, { useEffect, useMemo, useState } from "react";
import Header from "../../layout/Header";
import { fetchAPI } from "../../service/Encrtyption";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { claimStatus, genuityCheckData, myRewards, reclaimDataSave, rewardMoney } from "../../auth/redux/store";
import ReactGA from 'react-ga4';
import { Button } from "react-bootstrap";
import Rewards from "../../../assets/images/Rewards.png"

export const SpinNotApplicable = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const currentLanguage = lang;
    const [formData, setFormData] = useState({});
    const [programName, setProgramName] = useState('');
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(false);
    const user = useSelector((state) => state?.user);
    const amount = useSelector((state) => state?.amount);
    const [errroMsg, setErrorMsg] = useState("");
    const browserType = sessionStorage.getItem("browserName") || "web";
    const location = useLocation();
    const mobileNumber = sessionStorage.getItem('mbn');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const genunityData = useSelector((state) => state?.genunityData);


    const hide = () => {
        setErrorMsg("");
    };

    return (
        <>
            <Header />
            <div className="main">

                <div className="container">
                    {loading && <Loader />}

                    {/* <div className="text-center mt-4">
                        <h5 className="card-title mb-0">{t('scan_more_win_bigger_gifts_title')}</h5>
                        <p className="card-text mb-0">{t('scan_more_win_bigger_gifts_desc')}</p>

                        <div className="" style={{ marginBottom: "6rem", marginTop: "6rem" }}>
                            <p className="card-text">{t('next_gift_label')}</p>
                            <h2 className="text-center text-secondaryColor scanCount">5</h2>
                            <p className="card-text ">{t('scan_more_packets_label')}</p>
                        </div> 
                    </div> */}

                    <div className="text-center mt-4">
                        {genunityData?.nextLevelMsg && (<p
                            dangerouslySetInnerHTML={{
                                __html: genunityData?.nextLevelMsg?.replace(/\n/g, "<br/>") || "",
                            }}
                        />
                        )}
                    </div>

                    <div className="d-flex flex-direction-column bottomBtns" style={{ gap: "1rem" }}>
                        <Button className="rounded-4 py-2 btnshadow btn-secondary mx-auto" style={{ width: "90%" }}
                            onClick={() => {

                                ReactGA.event({
                                    category: "User Reward History",
                                    label: "Reward History Button",
                                    action: "Clicked Reward History Button - Spin Not Applicable",
                                });
                                navigate(`/${lang}/giftHistory`)
                            }}
                        >
                            {t('reward_history')}
                        </Button>

                        <Button className="rounded-4 py-2 btnshadow btn-secondary mx-auto" style={{ width: "90%" }}
                            onClick={() => {
                                ReactGA.event({
                                    category: "Btn", 
                                    label: "User Scan More",
                                    action: "Clicked Scan More Button - Spin Not Applicable"
                                });
                                navigate(`/${lang}/scanProduct`)
                            }}>
                            {t("Scanmore")}
                        </Button>
                    </div>

                    {errroMsg && (
                        <>
                            <div
                                className="alert alert-warning alert-dismissible fade show mt-2"
                                role="alert"
                            >
                                {errroMsg}
                                <button
                                    type="button"
                                    className="close"
                                    onClick={hide}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </>
                    )}


                </div>
            </div>
        </>
    );
};
